import styled from 'styled-components';

interface CoverInterface {
    src?: string;
    height?: string;
}

interface LogoInterface {
    src?: string;
    height?: string;
    width?: string;
}

export const CoverWrapper = styled.div<CoverInterface>`
    width: 100%;
    height: ${({ height }) => height || '300px'}; 
    background-color: #ccc;
    background: ${({ src }) => (src ? `url(${src})` : 'none')};
    background-size: cover;
    background-position: center;
    border-radius: 6px;
    position: relative;
`;

export const LogoWrapper = styled.div<LogoInterface>`
    position: absolute;
    left: 15px;
    bottom: 15px;
    height: ${({ height }) => height || '80px'};
    width: ${({ width }) => width || '80px'};
    background: ${({ src }) => (src ? `url(${src})` : 'none')};
    background-color: ${({ theme }) => theme.mode === 'dark' ? '#374151' : '#f3f3f3'};
    border-radius: 6px;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const EmptyCoverPlaceholder = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.mode === 'dark' ? '#9ca3af' : '#6b7280'};
    opacity: 0.5;
`;

export const EmptyLogoPlaceholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.mode === 'dark' ? '#6b7280' : '#9ca3af'};
    opacity: 0.6;
`;
